<template>
  <path
    style="fill: rgb(227, 59, 59)"
    d="M32,64c-8.5,0-16.6-3.3-22.6-9.4C3.3,48.6,0,40.5,0,32c0-8.5,3.3-16.6,9.4-22.6C15.4,3.3,23.5,0,32,0
                                                    c8.5,0,16.6,3.3,22.6,9.4c12.5,12.5,12.5,32.8,0,45.3C48.6,60.7,40.6,64,32,64 M32,3.8c-7.5,0-14.6,2.9-20,8.3
                                                    c-5.3,5.3-8.3,12.4-8.3,20c0,7.5,2.9,14.6,8.3,20c5.3,5.3,12.4,8.3,20,8.3c7.5,0,14.6-2.9,20-8.3C63,41,63,23,52,12
                                                    C46.6,6.7,39.5,3.8,32,3.8 M39.8,41.7c-0.5,0-1-0.2-1.3-0.6L32,34.7l-6.4,6.4c-0.4,0.4-0.8,0.6-1.3,0.6c-0.5,0-1-0.2-1.3-0.6
                                                    c-0.7-0.7-0.7-1.9,0-2.7l6.4-6.4l-6.4-6.4c-0.7-0.7-0.7-1.9,0-2.7c0.4-0.4,0.8-0.6,1.3-0.6c0.5,0,1,0.2,1.3,0.6l6.4,6.4l6.4-6.4
                                                    c0.4-0.4,0.8-0.6,1.3-0.6s1,0.2,1.3,0.6c0.7,0.7,0.7,1.9,0,2.7L34.7,32l6.4,6.4c0.7,0.7,0.7,1.9,0,2.7
                                                    C40.8,41.5,40.3,41.7,39.8,41.7"
  />
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconKruisAppendix extends Vue {}
</script>
